import { render, staticRenderFns } from "./LeagueMyViewermove.vue?vue&type=template&id=12236c62&"
import script from "./LeagueMyViewermove.vue?vue&type=script&lang=js&"
export * from "./LeagueMyViewermove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports